
<div class="scr-sl-picker" #scrPicker>
    <div *ngIf="list?.length == 0" class="us-db-empty">{{textEmpty}}</div>
    <div class="scr-sl-highlight" #scrHighlight></div>
    <div class="scr-sl-list" #scrList>
        <div *ngFor="let item of list; let i = index" class="scr-sl-item" (click)="onSelectItem(i)"
        [attr.dpad]="dpadZone" [style.--scale-dpad]="1" x-dpad="0" [attr.y-dpad]="i">
            <span class="pl-2 scr-sl-item-name">{{item}}</span>
        </div>
    </div>

</div>